export type OrderType = 'limit' | 'market' | 'stop' | 'stop_limit'
export type OrderSide = 'buy' | 'sell'
export type OrderStatus = 'open' | 'filled' | 'cancelled' | 'partial'

export interface IOrder {
  coinigyOrderId: string | number
  displayName: string
  marketName: string
  openTime: string | Date
  closeTime: string | Date
  exchange: string
  limitPrice: number | string
  stopPrice: number | string
  baseCurrency: string
  quoteCurrency: string
  exchCode: string
  orderType: OrderType | string
  quantity: number | string
  status: OrderStatus | string
  authId: string | number
  side: OrderSide | string
}

export class Order implements IOrder {
  constructor(
    public coinigyOrderId: string | number = '',
    public displayName: string = '',
    public marketName: string = '',
    public openTime: string | Date = '',
    public closeTime: string | Date = '',
    public exchange: string = '',
    public limitPrice: number | string = '',
    public stopPrice: number | string = '',
    public baseCurrency: string = '',
    public quoteCurrency: string = '',
    public exchCode: string = '',
    public orderType: OrderType | string = '',
    public quantity: number | string = '',
    public status: OrderStatus | string = '',
    public authId: string | number = '',
    public side: OrderSide | string = ''
  ) {}
}

export default Order 